/**
 * SS PDP FAQ — <ss-pdp-faq>
 * Accordion (optionally one open at a time), deep links (#question id opens
 * that row), keyboard friendly. No text or URLs here.
 */
(function () {
  'use strict';
  if (customElements.get('ss-pdp-faq')) return;

  class SsPdpFaq extends HTMLElement {
    constructor() { super(); this._listeners = []; }

    connectedCallback() {
      this.singleOpen = this.dataset.singleOpen === 'true';
      this.querySelectorAll('[data-ss-faq-toggle]').forEach(function (button) {
        this.on(button, 'click', function () { this.toggle(button); }.bind(this));
      }, this);
      this.openFromHash();
      this.on(window, 'hashchange', this.openFromHash.bind(this));
    }

    disconnectedCallback() {
      this._listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); });
      this._listeners = [];
    }

    on(el, type, fn) { el.addEventListener(type, fn); this._listeners.push([el, type, fn]); }

    toggle(button, forceOpen) {
      var item = button.closest('[data-ss-faq-item]');
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!item || !panel) return;
      var open = forceOpen === true ? true : !item.classList.contains('is-open');
      if (open && this.singleOpen) {
        this.querySelectorAll('[data-ss-faq-item].is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var b = other.querySelector('[data-ss-faq-toggle]');
          var p = b && document.getElementById(b.getAttribute('aria-controls'));
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });
      }
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    /* #SsFaq-<section>-q-3 or #SsFaq-<section>-a-3 in the URL opens that question */
    openFromHash() {
      var hash = (window.location.hash || '').replace('#', '');
      if (!hash) return;
      var target = document.getElementById(hash);
      if (!target || !this.contains(target)) return;
      var button = target.matches('[data-ss-faq-toggle]') ? target : target.closest('[data-ss-faq-item]') && target.closest('[data-ss-faq-item]').querySelector('[data-ss-faq-toggle]');
      if (button) { this.toggle(button, true); button.focus(); }
    }
  }

  customElements.define('ss-pdp-faq', SsPdpFaq);
})();
